"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SORT_CHANNEL_BY_QUERY_NAME = void 0;
exports.useChannelSortOptionsFromQueryString = useChannelSortOptionsFromQueryString;
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _queryString = require("query-string");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SORT_CHANNEL_BY_QUERY_NAME = 'sort_channels_by';

// we need to sort chat by updated_at when navigate to chats from other page
// this is because of channels pagination, when channel is not in first chunk we cannot open it
// the workaround is to call backend to update channel and sort by updated_at. In this case
// target channel will be the first in the list
exports.SORT_CHANNEL_BY_QUERY_NAME = SORT_CHANNEL_BY_QUERY_NAME;
function useChannelSortOptionsFromQueryString() {
  var defaultSort = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var _useLocation = (0, _reactRouterDom.useLocation)(),
    search = _useLocation.search;
  var sort = (0, _react.useMemo)(function () {
    if (!search) {
      return defaultSort;
    }
    var query = (0, _queryString.parse)(search.substring(1));
    var sortBy = query && query[SORT_CHANNEL_BY_QUERY_NAME];
    if (!sortBy) {
      return defaultSort;
    }
    return [_defineProperty({}, sortBy, -1)];
  }, []);
  return sort;
}